import { Box } from '@mui/material';
import { PRESETS, Preset, resolveTheme } from '@porter/shared-theme';
import { LINE, LINE_MID, resetButton, ring } from './constants';

interface Props {
  presetId?: string | null;
  onSelect: (preset: Preset) => void;
}

function PresetCard({
  preset,
  selected,
  onSelect,
}: {
  preset: Preset;
  selected: boolean;
  onSelect: (preset: Preset) => void;
}) {
  const t = resolveTheme({
    backgroundId: preset.bg,
    primaryId: preset.primary,
    accentId: preset.accent,
    fontId: preset.font,
  });

  return (
    <Box
      component="button"
      type="button"
      onClick={() => onSelect(preset)}
      aria-pressed={selected}
      sx={{
        ...resetButton,
        position: 'relative',
        border: `1px solid ${LINE_MID}`,
        borderRadius: '8px',
        overflow: 'hidden',
        background: '#fff',
        '&::after': ring(selected),
      }}>
      <Box
        sx={{
          height: 76,
          padding: '8px',
          background: t.bg,
          display: 'flex',
          flexDirection: 'column',
          gap: '5px',
        }}>
        <Box sx={{ height: 20, background: 'rgba(150, 150, 150, 0.55)' }} />
        <Box
          sx={{
            fontFamily: t.headFont,
            fontSize: 10,
            fontWeight: 700,
            color: t.fg,
            lineHeight: 1,
          }}>
          Porter Studio
        </Box>
        <Box sx={{ height: 3, width: '60%', background: t.dim }} />
        <Box
          sx={{
            marginTop: 'auto',
            height: 12,
            boxSizing: 'border-box',
            borderRadius: '3px',
            border: t.primaryEdge,
            background: t.primary,
          }}
        />
      </Box>
      <Box
        sx={{
          padding: '7px 8px',
          borderTop: `1px solid ${LINE}`,
          fontSize: 12,
          fontWeight: 700,
          color: 'text.primary',
        }}>
        {preset.name}
      </Box>
    </Box>
  );
}

function PresetGrid({ presetId, onSelect }: Props) {
  return (
    <Box sx={{ flex: 'none' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'baseline',
          justifyContent: 'space-between',
          gap: 1,
          marginBottom: '10px',
        }}>
        <Box sx={{ fontSize: 16, fontWeight: 700, color: 'text.primary' }}>
          Presets
        </Box>
        <Box sx={{ fontSize: 12, color: 'text.tertiary' }}>
          Sets background, primary, accent and font
        </Box>
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(4, 1fr)' },
          gap: '10px',
        }}>
        {PRESETS.map(preset => (
          <PresetCard
            key={preset.id}
            preset={preset}
            selected={preset.id === presetId}
            onSelect={onSelect}
          />
        ))}
      </Box>
    </Box>
  );
}

export default PresetGrid;
